import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import { logout as leadLogout } from "../slices/leadsSlice";
import { resetCurrentPageTitle } from "./pageSlice";

const setGroupAccessInStorage = (payload = {}) => {
  const resolvedGroupId = payload.groupid ?? payload.groupId;
  const resolvedGroupIds = payload.groupids ?? payload.groupIds;

  if (resolvedGroupId !== undefined && resolvedGroupId !== null) {
    localStorage.setItem("groupid", String(resolvedGroupId));
  } else {
    localStorage.removeItem("groupid");
  }

  if (resolvedGroupIds !== undefined && resolvedGroupIds !== null) {
    localStorage.setItem("groupids", JSON.stringify(resolvedGroupIds));
  } else {
    localStorage.removeItem("groupids");
  }
};

export const tryLogin = createAsyncThunk(
  "session/tryLogin",
  async ({ email, password, loginSuccessCallback,loginFailureCallback }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/user/login", {
        email,
        password,
      });
      if (response?.data.token) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("name", response.data.name);
        localStorage.setItem("lastName", response.data.lastName);
        localStorage.setItem("auth", response.data.auth);
        localStorage.setItem("userRole", response.data.auth);
        localStorage.setItem('Roles', response.data.customRoles)
        localStorage.setItem('lastName', response.data.lastName)
        localStorage.setItem('email', response.data.email)
        // Group access (supports groupid/groupId and groupids/groupIds)
        setGroupAccessInStorage(response.data);
        localStorage.setItem(
          "countrycode",
          response.data.countrycode || response.data.user?.countrycode || ""
        );
        localStorage.setItem(
          "region",
          response.data.region || response.data.user?.region || ""
        );
        localStorage.setItem("SuperUser", response.data.auth === "L0" ? "1" : "0");
        loginSuccessCallback(response.data.auth)
      }
      return response.data; // Return user session data
    } catch (error) {
            loginFailureCallback?.(); // ✅ Call it here on failure
      return rejectWithValue(error.response?.data || "Login failed");
    }
  }
);

export const trySuperLogin = createAsyncThunk(
  "session/trySuperLogin",
  async ({ Level, loginSuccessCallback }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/employees/switchuser", { Level });
      const { token: Switchtoken } = response.data;
      if (Switchtoken && response.data) {
        localStorage.setItem("token", Switchtoken);
        localStorage.setItem("name", response.data.name);
        localStorage.setItem("lastName", response.data.lastName);
        localStorage.setItem("auth", response.data.auth);
        localStorage.setItem("Roles", response.data.customRoles);
        localStorage.setItem('email', response.data.email)
        localStorage.setItem(
          "countrycode",
          response.data.countrycode || response.data.user?.countrycode || ""
        );
        localStorage.setItem(
          "region",
          response.data.region || response.data.user?.region || ""
        );
        localStorage.setItem("SuperUser", "1");
        localStorage.setItem("userRole", response.data.auth);
        setGroupAccessInStorage(response.data);
        loginSuccessCallback(response.data.auth);
      }
      return response.data; // Return user session data
    } catch (error) {
      return rejectWithValue(error.response?.data || "Login failed");
    }
  }
);


export const checkSession = () => (dispatch) => {
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("userRole");
  const email = localStorage.getItem("email");
  const name = localStorage.getItem("name");
  const lastName = localStorage.getItem("lastName");
  const auth = localStorage.getItem("auth");
  const customRoles = localStorage.getItem("Roles");
  const countrycode = localStorage.getItem("countrycode");
  const region = localStorage.getItem("region");
  const groupid = localStorage.getItem("groupid");
  const groupids = localStorage.getItem("groupids");

  if (token && userRole && email) {    
    dispatch({
      type: "session/restoreSession",
      payload: {
        token,
        auth,
        userRole,
        email,
        name,
        lastName,
        customRoles,
        countrycode,
        region,
        groupid,
        groupids,
      },
    });
  } else {
    dispatch(sessionSlice.actions.logout());
  }
};


export const logoutSession = (e) => (dispatch) => {
  if (e) e.preventDefault(); // Prevent default if event exists
  localStorage.removeItem("token"); // Remove token from localStorage
  localStorage.removeItem("url"); // Remove url from localStorage groupAssigned
  localStorage.removeItem("groupAssigned"); // Remove url from localStorage  authLevel
  localStorage.removeItem("name"); // Remove url from localStorage
  localStorage.removeItem("email"); // Remove url from localStorage   userRole
  localStorage.removeItem("userRole"); // Remove url from localStorage
  localStorage.removeItem("auth"); // Remove url from localStorage /
  localStorage.removeItem("Roles"); // Remove url from localStorage 
  localStorage.removeItem("lastName"); // Remove url from localStorage 
  localStorage.removeItem("SuperUser"); // Remove url from localStorage 
  localStorage.removeItem("countrycode");
  localStorage.removeItem("region");
  localStorage.removeItem("groupid");
  localStorage.removeItem("groupids");
  dispatch(sessionSlice.actions.logout());
  dispatch(leadLogout())
  dispatch(resetCurrentPageTitle(''))
};

const sessionSlice = createSlice({
  name: "session",
  initialState: { 
    session: null, 
    loading: false, 
    error: null,
    loginAttempts: 0, // ✅ Add this
 },
  reducers: {
    logout: (state) => {
      state.session = null;
      state.loading = false;
      state.error = null;
    },
    restoreSession: (state, action) => {
      state.session = action.payload;
      state.loading = false;
      state.error = null;
    },
        incrementLoginAttempts(state) {
      state.loginAttempts += 1;
    },
    resetLoginAttempts(state) {
      state.loginAttempts = 0;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(tryLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(tryLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.session = action.payload;
        localStorage.setItem("token", action.payload.token);
        localStorage.setItem("userRole", action.payload.auth);
        localStorage.setItem("email", action.payload.email);
        localStorage.setItem("Roles", action.payload.customRoles);
        localStorage.setItem("name", action.payload.name);
        localStorage.setItem("lastName", action.payload.lastName);
        setGroupAccessInStorage(action.payload);
      })
      .addCase(tryLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    // trySuperLogin
    builder
      .addCase(trySuperLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(trySuperLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.session = action.payload;
      })
      .addCase(trySuperLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },

});
export const { incrementLoginAttempts, resetLoginAttempts } = sessionSlice.actions;
export default sessionSlice.reducer;